import React, { useState } from "react";
import "./SignUp.css";
import { FaGoogle } from "react-icons/fa";
import {
  signInWithPopup,
  GoogleAuthProvider,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../Nav/TopNavbar";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const googleLogin = () => {
    const provider = new GoogleAuthProvider();
    setIsLoading(true);
    signInWithPopup(auth, provider)
      .then((result) => {
        navigate("/dashboard");
      })
      .catch((error) => {
        setError("Google login failed. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const emailLogin = () => {
    if (!email || !password) {
      setError("Please fill in all fields.");
      return;
    }
    setIsLoading(true);
    signInWithEmailAndPassword(auth, email, password)
      .then(() => {
        navigate("/dashboard");
      })
      .catch((error) => {
        setError("Invalid email or password. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <TopNavbar />
      <div className="bg">
        <div className="signup">
          <div className="signup-connect">
            <h1 style={{ color: "#7620FF" }}>Login with Google</h1>
            <button
              className="btn btn-google"
              onClick={googleLogin}
              disabled={isLoading}
            >
              <FaGoogle style={{ marginRight: "10px" }} />
              {isLoading ? "Signing in..." : "Sign in with Google"}
            </button>
          </div>
          <div className="signup-classic">
            <h2 style={{ fontWeight: "600", fontSize: "25px" }}>Login</h2>
            {error && <p className="error">{error}</p>}
            <div className="form">
              <fieldset className="email">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ color: "black" }}
                  placeholder="Email"
                  disabled={isLoading}
                />
              </fieldset>
              <fieldset className="password">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ color: "black" }}
                  placeholder="Password"
                  disabled={isLoading}
                />
              </fieldset>
              <button
                className="btn"
                onClick={emailLogin}
                disabled={isLoading}
              >
                {isLoading ? "Logging in..." : "Login"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
